import { useTranslation } from "react-i18next";
import "./styles.scss";
import Button from "components/button/Button";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { useEffect, useRef, useState } from "react";
import useDetectScrolledToBottom from "hooks/useDetectScrolledToBottom";

const TermsPolicy = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();
  const [isAccept, setIsAccept] = useState(false);

  const node = useRef();
  const { isBottom } = useDetectScrolledToBottom(node);

  useEffect(() => {
    if (!isAccept && isBottom) {
      setIsAccept(true);
    }
  }, [isBottom]);

  return (
    <div className="policy-container">
      {/* <img src="/icons/logo.webp" className="logo-icon" /> */}
      <div className="policy-content" ref={node}>
        <br />
        利用規約
        <br />
        この規約（以下「本規約」といいます。）は、三和株式会社（以下「当社」といいます。）が提供する
        当システムに関するすべての製品およびサービス（以下「本サービス」といいます。）の利用に関する条件を、本サービスを利用する方（以下「ご利用者」といいます。）と当社との間で定めるものです。
        <br />
        <br />
        1. 定義
        <br />
        本規約では、以下の用語を使用します。
        <br />
        1.1.
        「コンテンツ」とは、文章、画像、ソフトウェア、プログラム、コード、データその他の情報のことをいいます。
        <br />
        1.2.
        「本コンテンツ」とは、本サービスを通じてアクセスすることができるコンテンツのことをいいます。
        <br />
        <br />
        2. 規約への同意
        <br />
        2.1.
        ご利用者は、本規約の定めに従って本サービスを利用しなければなりません。ご利用者は、本規約に有効かつ取消不能な同意をしないかぎり本サービスを利用できません。
        <br />
        2.2.
        ご利用者は、本サービスを実際に利用することによって本規約に有効かつ取消不能な同意をしたものとみなされます。
        <br />
        <br />
        3. 規約の変更
        <br />
        3.1.
        当社は、当社が必要と判断する場合、あらかじめお客様に通知することなく、いつでも、本規約および個別利用規約を変更できるものとします。
        <br />
        3.2.
        ご利用者は本規約および個別利用規約の変更後も本サービスを使い続けることにより、変更後の本規約および適用のある個別利用規約に対する有効かつ取消不能な同意をしたものとみなされます。
        <br />
        <br />
        4. プライバシー
        <br />
        4.1. 当社は、ご利用者のプライバシーを尊重しています。
        <br />
        4.2.
        当社は、ご利用者のプライバシー情報と個人情報を、当社のプライバシーポリシーに従って適切に取り扱います。
        <br />
        4.3.
        当社は、ご利用者から収集した情報を安全に管理するため、セキュリティに最大限の注意を払っています。
        <br />
        <br />
        5. コンテンツ
        <br />
        5.1.
        当社がご利用者に対し提供する本コンテンツに関する知的財産権その他の権利はご利用者に移転せず、ご利用者は、着用者の介護のために必要な範囲で利用することができます。
        <br />
        5.2.
        ご利用者は、本コンテンツを、着用者の介護に現実に必要な範囲以外に利用(複製、送信、転載、改変、リバースエンジニアリングなどの行為を含みます。)してはなりません。
        <br />
        <br />
        6. ご利用者の責任
        <br />
        6.1.
        ご利用者は、ご利用者ご自身の責任において本サービスを利用するものとし、本サービスにおいて行った一切の行為およびその結果について一切の責任を負うものとします。
        <br />
        6.2.
        当社は、ご利用者が本規約に違反して本サービスを利用していると認めた場合、当社が必要かつ適切と判断する措置を講じます。ただし、当社は、かかる違反を防止または是正する義務を負いません。
        <br />
        <br />
        7. 当社の免責
        <br />
        7.1.
        当社は、本サービス（本コンテンツを含みます。）に事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
        <br />
        7.2.
        当社は、ご利用者に対して、かかる瑕疵を除去して本サービスを提供する義務を負いません。
        <br />
        7.3.
        当社は、本サービスに起因してご利用者に生じたあらゆる損害について一切の責任を負いません。ただし、本サービスに関する当社とご利用者との間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合、この免責規定は適用されません。
        <br />
        <br />
        8. 準拠法、裁判管轄
        <br />
        本規約は日本語を正文とし、その準拠法は日本法とします。本サービスに起因または関連してご利用者と当社との間に生じた紛争については東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
        <br />
        <br />
        データ送信許諾 <br />
        この許諾書（以下「本許諾」といいます。）は、三和株式会社（以下「当社」といいます。）と、本サービスを利用する方（以下「ご利用者」といいます。）との間で定めるものです。
        <br />
        <br />
        1. データの内容
        <br />
        本サービスで使用するデータ（以下「本データ」といいます。）とは、ご利用者が入力した情報及び当社のシステムによって得られた全ての情報のことをいいます。
        <br />
        <br />
        2. 使用許諾の範囲 <br />
        2.1.
        当社は、使用を許諾された本データを、医学研究・尿とりパッド開発・利用者の業務アドバイスにおける情報解析にのみ使用できるものとする。
        <br />
        2.2.
        本データの使用者の範囲は、個人又は当社の属するグループ若しくは研究室の構成員に限定し、人数は必要最小限とします。
        <br />
        <br />
        3. 知見の発表 <br />
        3.1.
        当社は、本覚書に違反しない範囲において、本データを使用して得られた知見に関する研究発表又は成果の公表を行なうことができることとします。
        <br />
        3.2.
        研究成果の公表には、第2条に違反しない範囲において、本データを利用して得られたデータ又は処理プログラムの公開を含むものとします。
        <br />
        <br />
        4. 管轄裁判所
        <br />
        本覚書に関する一切の訴訟については、東京地方裁判所を専属的な合意管轄裁判所とします。
        <br />
        <br />
        プライバシーポリシー
        <br />
        当社が保有する個人データは、次の事項に該当する場合を除き、それぞれのサービスおよび業務の利用目的
        (医学研究における情報解析)
        の達成に必要な範囲で利用するほか、相互に利用することがあります。 <br />
        ・ 法令に基づく場合
        <br />・
        人の生命、身体または財産の保護のために必要がある場合であって、ご利用者本人の同意を得ることが困難であるとき
        <br />・
        公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客さま本人の同意を得ることが困難であるとき
        <br />・
        国の機関もしくは地方公共団体またはその委託を受けた者が法令に定める事務をすることに対して協力する必要がある場合であって、お客さま本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
        <br />
        <br />
        当社は、匿名加工情報を作成するときは、特定の個人を識別することおよびその作成に用いる個人情報を復元することができないようにするために必要な措置を取ります。
        <br />
        また、匿名加工情報を自ら利用するときは、元の個人情報に係る本人を識別
        (再識別) する目的で他の情報と照合することを行いません。
        <br />
        <br />
        当社は、個人情報へのアクセスの管理、個人情報の持出し手段の制限、外部からの不正なアクセスの防止のための措置その他の個人情報の漏えい、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。
      </div>
      <Button
        text={id === "1" ? t("termsPolicy.returnToLogin") : t("button.accept")}
        className="policy-button"
        disabled={id !== "1" && !isAccept}
        onClick={() =>
          history.push(id === "1" ? ROUTE.PUBLIC.LOGIN : ROUTE.PUBLIC.SIGN_UP)
        }
      />
    </div>
  );
};

export default TermsPolicy;
